module.exports = __webpack_public_path__ + "img/sofortueberweisung-data.dab9d14f.svg";